export default __webpack_public_path__ + "static/media/banner8en.18bc7f23.png";